import axios from 'axios'
//import { VImg } from 'vuetify/lib'
const GlobalConfig = {

  install(Vue) {
    Vue.mixin({
      methods: {
        /*
          Calculate the Age based on date passed (YYYY-MM-DD) to the function
        */
        calculateAge(year, month, day) {
          var today = new Date()
          var birthDate = new Date(year, month, day)
          var age = today.getFullYear() - birthDate.getFullYear()
          var m = today.getMonth() - birthDate.getMonth()
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--
          }
          return age
        },
        getExternalContactPreferences(ssoid) {
          return new Promise((resolve) => {
            console.log('Attempting to get contact prefernces from external source')
            switch (this.configValues.contactPreferencesParentSystem) {
              case 'XCM':
                resolve(this.crmXCMGetPreferences(ssoid))
                break;
              case 'G4':
                  resolve(this.crmG4GetPreferences(ssoid))
                  break;
              case 'Dummy':
                resolve(this.dummyCRMGetPreferences())
                break;
              default:
                resolve(null)
                break;
            }
          })
        },
        dummyCRMGetPreferences() {
          return new Promise((resolve) => {
            console.log('triggered dummy crm push')
            var dummyUserData = {
              clubEmail: 'Y',
              clubPhone: 'Y',
              clubDirect: 'Y',
              clubSMS: 'Y'
            }
            resolve(dummyUserData)
          })
        },
        dummyCRMPushFunction() {
          return new Promise((resolve) => {
            console.log('triggered dummy crm push')
            resolve()
          })
        },
        crmXCMPushFunction(username) {
          var crmXCMPushURL = this.configValuesxcmConfig.pushDataEndpoint + username
          console.log('XCM push url', crmXCMPushURL)
          return axios({
            method: 'get',
            url: crmXCMPushURL
          })
        },
        crmXCMGetPreferences (ssoid) {
          return new Promise((resolve, reject) => {

            var crmURL = this.configValuesxcmConfig.contactPreferencesEndpoint + ssoid
            console.log('XCM push url', crmURL)
            axios({
              method: 'get',
              url: crmURL
            }).then(function (response) {
              console.log('XCM response', response)
              if (response.data.success === true) {
                console.log('XCM prefs found, setting local values to XCM values')
                var xcmData = response.data.data.Preferences
                var userData = {} // a dummy object to place our normalised data back into
                userData.clubEmail = ((xcmData['Email']['Club Communication'] == 'Y') ? true : false)
                userData.clubDirect = ((xcmData['Direct Mail']['Club Communication'] == 'Y') ? true : false)
                userData.clubPhone = ((xcmData['Phone']['Club Communication'] == 'Y') ? true : false)
                userData.clubSMS = ((xcmData['SMS']['Club Communication'] == 'Y') ? true : false)
                userData.partnerEmail = ((xcmData['Email']['Partner Communication'] == 'Y') ? true : false)
                userData.partnerDirect = ((xcmData['Direct Mail']['Partner Communication'] == 'Y') ? true : false)
                userData.partnerPhone = ((xcmData['Phone']['Partner Communication'] == 'Y') ? true : false)
                userData.partnerSMS = ((xcmData['SMS']['Partner Communication'] == 'Y') ? true : false)
                userData.clubAds = ((xcmData['Digital Ads']['Club Communication'] == "Y") ? true : false)
                userData.foundationEmail = ((xcmData['Email']['AV Foundation'] == "Y") ? true : false)
                userData.partnerAds = ((xcmData['Digital Ads']['Partner Communication'] == "Y") ? true : false)
                resolve(userData)
              } else {
                reject(new Error('XCM failed to respond'))
              }
            })
          })
        },
        crmG4PushFunction(ssoid) {
          var vm = this
          return new Promise((resolve, reject) => {

            var crmG4PushURL = vm.configValues.g4Config.pushDataEndpoint + ssoid
            console.log('G4 push started')
            axios({
              method: 'get',
              url: crmG4PushURL
            }).then(function (response) {

              if (response.data.success === true) {
                resolve(response.data)
              } else {
                reject(new Error('G4 failed to respond'))
              }
            })
            .catch(function(error) {
              reject(error)
            });
          })
        },
        crmG4GetPreferences (ssoid) {
          var vm = this
          return new Promise((resolve, reject) => {

            var crmURL = vm.configValues.g4Config.contactPreferencesEndpoint + ssoid
            console.log('G4 GET url', crmURL)
            axios({
              method: 'get',
              url: crmURL
            }).then(function (response) {

              if (response.data.success === true) {
                
                var g4Data = response.data.response
                console.log('G4 prefs found, setting local values to G4 values')
                var userData = {} // a dummy object to place our normalised data back into
                userData.clubEmail = ((g4Data['EmailOptin'] == true) ? true : false)
                userData.clubDirect = ((g4Data['MailOptin'] == true) ? true : false)
                userData.clubPhone = ((g4Data['PhoneOptin'] == true) ? true : false)
                userData.clubSMS = ((g4Data['SmsOptin'] == true) ? true : false)
                userData.partnerEmail = ((g4Data['ThirdPartyEmailOptin'] == true) ? true : false)
                userData.partnerDirect = ((g4Data['ThirdPartyMailOptin'] == true) ? true : false)
                userData.partnerPhone = ((g4Data['ThirdPartyPhoneOptin'] == true) ? true : false)
                userData.partnerSMS = ((g4Data['ThirdPartySMSOptin'] == true) ? true : false)
                resolve(userData)
              } else {
                reject(new Error('G4 failed to respond'))
              }
            })
          })
        },
        dataPush (ssoid) {
          return new Promise((resolve) => {
            console.log('Establishing enpoints to push data')
            // build list of data push functions that we need to trigger
            var dataPushFunctions = []

            console.log(this.configValues)

            if (this.configValues.dummyCRMEnabled === true) {
              dataPushFunctions.push(this.dummyCRMPushFunction)
            }

            if (this.configValues.g4CRMIntegrationEnabled === true) {
              dataPushFunctions.push(this.crmG4PushFunction(ssoid))
            }

            if (this.configValues.xcmCRMIntegrationEnabled === true) {
              dataPushFunctions.push(this.crmXCMPushFunction(ssoid))
            }

            Promise.all(dataPushFunctions)
              .then(function (results) {
                console.log('CRM update results', results[0])
                resolve()
              })
              .catch(function (error) {
                console.error('Error occurred during CRM update:', error.message);
                resolve()
              });

          })
        },
        ticketMasterLink (tmid) {
          var vm = this
          return new Promise(function (resolve, reject) {
            console.log('ticketmaster link account')


            if(vm.$getAuthenticatedUser() == null){
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              // check to see if the user was created with traditional registration (and not Facebook or Google)
              //get this session's tokens
              var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
              var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`) 
              
              vm.$getCurrentUserAttributes().subscribe((userData) => {
                
                if(userData['custom:client_ref_verified']!=='true'){
                  console.log('generating user login token')

                  var ssoid = userData['sub']

                  
                  //check if the user exists
                  axios({
                    method: 'get',
                    headers: { 'Authorization': idToken},
                    url: vm.configValues.ticketMasterConfig.uzTMLinkEnpoint + ssoid + '/' + tmid
                  }).then(function (response) {
                    console.log('Token endpoint reponse', response)
                    
                    resolve(response.data)
                  })

                } else {
                  reject({success: false, message: "Unable to link as existing link does not exist"})
                }
              })

            }
          })
        },
        ticketMasterUnlink () {
          var vm = this
          return new Promise(function (resolve, reject) {
            console.log('ticketmaster link account')


            if(vm.$getAuthenticatedUser() == null){
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              // check to see if the user was created with traditional registration (and not Facebook or Google)
              //get this session's tokens
              var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
              var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`) 
              
              vm.$getCurrentUserAttributes().subscribe((userData) => {
                
                if(userData['custom:client_ref_verified']==='true'){
                  console.log('generating user login token')

                  var ssoid = userData['sub']

                  
                  //check if the user exists
                  axios({
                    method: 'get',
                    headers: { 'Authorization': idToken},
                    url: vm.configValues.ticketMasterConfig.uzTMUnlinkEnpoint + ssoid 
                  }).then(function (response) {
                    console.log('Token endpoint reponse', response)
                    
                    resolve(response.data)
                  })

                } else {
                  reject({success: false, message: "Unable to unlink as existing link does not exist"})
                }
              })

            }
          })
        },
        ticketMasterCreate() {
            var vm = this
            return new Promise(function (resolve, reject) {
              console.log('ticketmaster create and link account')


              if(vm.$getAuthenticatedUser() == null){
                console.log('User is not logged in')
                vm.$router.push("/");
              } else {
                // check to see if the user was created with traditional registration (and not Facebook or Google)
                //get this session's tokens
                var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
                var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`) 
                
                vm.$getCurrentUserAttributes().subscribe((userData) => {
                  
                  if(userData['custom:client_ref_verified']!=='true'){
                    console.log('generating user login token')

                    var ssoid = userData['sub']

                    
                    //check if the user exists
                    axios({
                      method: 'get',
                      headers: { 'Authorization': idToken},
                      url: vm.configValues.ticketMasterConfig.uzTMCreateEnpoint + ssoid 
                    }).then(function (response) {
                      console.log('Token endpoint reponse', response)
                      
                      resolve(response.data)
                    })

                  } else {
                    reject({success: false, message: "Unable to create as existing user is linked"})
                  }
                })

              }
            })
        },
        ticketMasterGenerateToken() {
          var vm = this
          return new Promise(function (resolve, reject) {
            if(vm.$getAuthenticatedUser() == null){
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              // check to see if the user was created with traditional registration (and not Facebook or Google)
              vm.$getCurrentUserAttributes().subscribe((userData) => {
                if(userData['custom:client_ref_verified']==='true'){
                  console.log('generating user login token')
  
                  var ssoid = userData['sub']
  
                  //get this session's tokens
                  var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
                  var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`) 
                  
                  //check if the user exists
                  axios({
                    method: 'get',
                    headers: { 'Authorization': idToken},
                    url: vm.configValues.ticketMasterConfig.uzTokenEnpoint + ssoid
                  }).then(function (response) {
                    console.log('Token endpoint reponse', response)
                    
                    console.log('redirecting to ', response.data.returnurl)
                    resolve(response.data.returnurl)
                  })
  
                } else {
                  console.log('User not verified by ticketmaster, account must be linked')
                  resolve(false)
                }
              })
  
            }
          })
        },
        ticketMasterRedirectWithToken () {
          console.log('ticketmaster token generation')

          if(this.$getAuthenticatedUser() == null){
            console.log('User is not logged in')
            this.$router.push("/");
          } else {
            // check to see if the user was created with traditional registration (and not Facebook or Google)
            this.$getCurrentUserAttributes().subscribe((userData) => {
              if(userData['custom:client_ref_verified']==='true'){
                console.log('generating user login token')

                var ssoid = userData['sub']

                //get this session's tokens
                var lastSub = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
                var idToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`) 
                
                //check if the user exists
                axios({
                  method: 'get',
                  headers: { 'Authorization': idToken},
                  url: this.configValues.ticketMasterConfig.uzTokenEnpoint + ssoid
                }).then(function (response) {
                  console.log('Token endpoint reponse', response)
                  //clear any redirect cookies
                  localStorage.removeItem('returnUrl');
                  localStorage.removeItem('suppressToken');
                  localStorage.removeItem('responseType');
                  localStorage.removeItem('loginFlow');
                  console.log('redirecting to ', response.data.returnurl)
                  window.location = response.data.returnurl
                 
                  return true
                })

              } else {
                console.log('User not verified by ticketmaster, account must be linked')

              }
            })

          }
        },
        teamstoreLogin() {
          
          var vm = this
          return new Promise(function (resolve, reject) {
            console.log('Teamstore login called')
            if(vm.$getAuthenticatedUser() == null){
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
              var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`) 
              
              var returnUrlString = ''
              if(localStorage.returnUrl){
                returnUrlString = '?return_to=' + localStorage.returnUrl
              }
              axios({
                method: 'get',
                url: vm.configValues.teamstoreConfig.teamstoreLoginURL+returnUrlString,
                headers: {
                    Authorization: 'Bearer ' + idToken //the token is a variable which holds the token
                }
              }).then(function (response) {
                if(response.data.body.token){
                  console.log('multipass token received, redirceting', )
                  //clear localstorage
                  localStorage.removeItem('returnUrl');
                  localStorage.removeItem('suppressToken');
                  localStorage.removeItem('responseType');
                  localStorage.removeItem('loginFlow');
                  window.location = response.data.body.token
                } else{
                  console.log('no multipass token returned')
                }
              }).catch((error) => {
                console.log('error axio', error)
              })
            }
          })
        },
        /*
          An array of domains that the site trusts in order to perform redirects
          */
          getConfigTrustedDomains(){
            var trustedDomains = []
            this.configTrustedPlatforms.forEach(platform => {	
              platform.domains.forEach(domain => {
                trustedDomains.push(domain)
              })
            })
            return trustedDomains
          },
          /*
          Gets the redirect platform info (set by app in localStorage.redirectPlatform)
          */
          getRedirectPlatform(){
            var platform = this.configTrustedPlatforms.find(plat => {
              //TODO: remove this hardcoded URL
              var returnUrl = localStorage.returnUrl
              var found = false
              plat.domains.forEach(domain => {
                if(returnUrl.includes(domain)){
                 found = true
                } 
              })
              return found
            })
            return platform
          },

          getPlatformRequiresAddress(){
            console.log('getPlatformRequiresAddress called')
            return this.getRedirectPlatform().requireAddress
          },
          
          getPlatformRequiresAddressMessage(){
            console.log('getPlatformRequiresAddressMessage called')
            return this.getRedirectPlatform().requireAddressMessage
          },

          getPlatformRequiresAddressButton(){
            console.log('getPlatformRequiresAddressMessage called')
            return this.getRedirectPlatform().requireAddressButton
          },
          performRedirect(){
            console.log('Performing standard redirect')
            var firstQueryChar = '?' 
            if(localStorage.returnUrl.includes('?')){ // account for ? in string
              firstQueryChar = '&'  
            }
            var redirect = localStorage.returnUrl 
            var lastSub = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
            var idToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`) 
            if(!localStorage.suppressToken){
              redirect = redirect + firstQueryChar + 'token=' + idToken
            }
            console.log('redirecting to ' + redirect)
            localStorage.removeItem('returnUrl');
            localStorage.removeItem('suppressToken');
            localStorage.removeItem('responseType');
            localStorage.removeItem('loginFlow');
            window.location = redirect
          }

      },
      data: function () {
        return {
          get configStrings() {
            return {
              clubName: 'Celtic FC',
              productName: 'Celtic FC Digital Account',
              clubIdentifierName: 'Fan ID',
              clubStreamingPlatformName: 'Celtic TV',
              clubWebsiteLink: 'https://www.celticfc.com/',
              clubPrivacyPolicyLink: 'https://www.celticfc.com/help-and-faqs/privacy-policy/',
              clubSSOHelpLink: 'https://www.celticfc.com/help-and-faqs',
              clubSSOVerificationEmailAddress: 'noreply@celticfc.co.uk'
            }
          },

          get configValues() {
            return {
              clubRootDomain: 'celticfc.com',
              accountConsentRequired: true, // true or false
              accountConsentAge: 13, // numeric value
              accountDoBUpdatesAllowed: false, // true or false
              accountRegistrationPreferencesAreEmailOnly: false, //if true the registration opt-ins only opt users in to email (if false they opt in to all channels)
              accountRequestAddressOnFirstLogin: true, // true or false
              accountProfilePicturesAllowed: false, // true or false
              profilePictures: {
                s3Bucket: 'sso-images.celticfc.com'
              },
              accountGenderRequested: true, // true or false
              accountGenderList: [
                '',
                'Male',
                'Female',
                'Other',
                'Prefer not to say'
              ],
              footerLinks: [
                { title:'Terms of Use', url:'https://www.celticfc.com/help-and-faqs/website-terms-of-use' }, 
                { title:'Privacy Policy', url:'https://www.celticfc.com/help-and-faqs/privacy-policy' },
                { title:'Cookie Policy', url:'https://www.celticfc.com/help-and-faqs/cookie-policy' },
                { title:'Safeguarding Policy', url:'https://www.celticfc.com/club/safeguarding' },
                { title:'Contact Us', url:'https://www.celticfc.com/help-and-faqs' }
              ],
              profileOptions:[
                { title:'Profile' , tab: 'tab-1', show: true},
                { title:'Email' , tab: 'tab-2', show: true},
                { title:'Password' , tab: 'tab-3', show: true},
                { title:'Link Client Reference' , tab: 'tab-4', show: false},
                { title:'Preferences' , tab: 'tab-5', show: true},
              ],
              teamstoreConfig: {
                domain: 'store.celticfc.com',
                teamstoreLoginURL: 'https://shopify-sso.gc.celticfc.com/v1/gcsso/multipass/login'
              },
              contactPreferencesParentSystem: 'G4',// String (Dummy, G4, XCM, SportsAlliance etc.). null if not relevant
              // Seatgeek integration options
              seatGeekAccountLinkingEnabled: false, // true or false
              seatGeekConfig: {
                liveOrigin: 'https://tickets.celticfc.com',
                iframeURL: 'https://tickets.celticfc.com/test/'
              },
              // TicketMaster integration options
              ticketMasterAccountLinkingEnabled: false, // true or false
              ticketMasterShowButton: false, // true or false,
              ticketMasterDebugMode: false, // true or false,
              ticketMasterConfig: {
                domain: 'eticketing.co.uk',
                clubDirectory: '/celticfc',
                loginUrl: '/interfaces/mufcsinglelogin/login.aspx',
                uzTokenEnpoint: 'https://tmapi.gc.celticfcservices.co.uk/v1/user/get-token/',
                uzTMLinkEnpoint: 'https://tmapi.gc.celticfcservices.co.uk/v1/user/link/',
                uzTMUnlinkEnpoint: 'https://tmapi.gc.celticfcservices.co.uk/v1/user/unlink/',
                uzTMCreateEnpoint: 'https://tmapi.gc.celticfcservices.co.uk/v1/user/create/'
              },
              // Dummy CRM integration options
              dummyCRMEnabled: false,
              //G4 CRM
              g4CRMIntegrationEnabled: true,
              g4Config: {
                pushDataEndpoint: process.env.VUE_APP_G4_CRM_API+'user/push/',
                contactPreferencesEndpoint: process.env.VUE_APP_G4_CRM_API+'user/'
              },
              // XCM CRM integration options
              xcmCRMIntegrationEnabled: false,
              xcmConfig: {
                pushDataEndpoint: '',
                contactPreferencesEndpoint: 'https://domain.com/user/preferences/'
              },
              communitySchemeMarketingEnabled: false,
              communityScheme: {
                name: 'Celtic FC Community Trust'
              }
            }
          },
          /*
          An array of platforms and related behaviour information 
          that the site trusts in order to perform redirects
          */
          get configTrustedPlatforms() {
            return [
              {
                providor: 'CelticTV',
                domains: ['www.celticfc.tv'],
                requireAddress: false,
                requireAddressMessage: 'In order to buy a streaming pass, you must first set your address',
                requireAddressButton: null
              },
              {
                providor: 'Ticketmaster',
                domains: ['uat.eticketing.co.uk', 'www.eticketing.co.uk'],
                requireAddress: false,
                requireAddressMessage: 'In order to use the ticket website, you must first set your address',
                requireAddressButton: null
              },
              {
                providor: 'Teamstore',
                domains: ['store.celticfc.com', 'official-celtic-store.myshopify.com','cfc.staging1.celticfc.com'],
                requireAddress: false,
                requireAddressMessage: 'In order to use the club shop, you must first set your address',
                requireAddressButton: 'Save & Continue to Shop'
              },   
              {
                providor: 'Gamechanger',
                domains: ['celticfc.com', 'www.celticfc.com'],
                requireAddress: false,
                requireAddressMessage: 'In order use the website, you must first set your address',
                requireAddressButton: null
              },
            ]
          },

          /*
          An array of the items that will be populated in the Official Websites list of the portal
          */
          get configOfficialWebsites() {
            return [
              {
                title: 'Official website',
                URL: 'https://celticfc.com',
                target: '_blank'
              },
              {
                title: 'UZ Online Store',
                URL: 'https://store.celticfc.com',
                target: ''
              },
              {
                title: 'Tickets',
                URL: 'https://www.eticketing.co.uk/celtic/',
                target: '_blank',
                ticketMasterTokenLogin: true
              }
            ]
          }
        }
      }
    })
  }
}
export default GlobalConfig
